import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState } from "react";
import './App.scss';
import ElectionPage from "./Page/ElectionPage";
import Test from "./Page/Test";


function App() {
  return (
    <div>
      <BrowserRouter>
      <Routes>
        <Route
            path="/"
            element={<ElectionPage />}
          />
      </Routes>

      
      </BrowserRouter>
      
    </div>
  );
}

export default App;
